import { ArticleBoxProps } from '@/components/boxes';
import { GetWroteAboutUsQuery } from '@/api/sanity/generated';
import { WithRequiredPropertyAndNotNullable } from '@/types/withRequiredProperty';

export type WroteAboutUsItem = WithRequiredPropertyAndNotNullable<
	NonNullable<NonNullable<GetWroteAboutUsQuery['allWroteAboutUs']>[number]>,
	'name' | 'text' | 'date' | 'link'
>;

export function mapWroteAboutUsToArticles(
	wroteAboutUseItems: WroteAboutUsItem[]
): ArticleBoxProps[] {
	const articles: ArticleBoxProps[] = wroteAboutUseItems.map((item) => {
		return {
			name: item?.name,
			content: item?.text,
			date: item?.date as string,
			link: item?.link,
			tag: item?.source || null,
		};
	});

	return articles;
}
